/* Simply Murals — mural.js
   Wall size calculator: product price is treated as price per m².
   Width x height (cm) -> area -> quantity (whole m², rounded up),
   dimensions stored as line item properties. */
(function () {
  'use strict';

  function money(cents) {
    var format = (window.themeSettings && window.themeSettings.moneyFormat) || '£{{amount}}';
    var value = (cents / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
  }

  document.querySelectorAll('[data-wall-calculator]').forEach(function (calc) {
    var wrapper = calc.closest('[data-product-wrapper]');
    var form = wrapper && wrapper.querySelector('form[data-product-form]');
    if (!form) return;

    var widthInput = calc.querySelector('[data-wall-width]');
    var heightInput = calc.querySelector('[data-wall-height]');
    var areaOut = calc.querySelector('[data-wall-area]');
    var totalOut = calc.querySelector('[data-wall-total]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var addBtn = form.querySelector('[data-add-to-cart]');
    var minArea = parseInt(calc.getAttribute('data-min-area'), 10) || 1;

    // hidden line item properties
    var propWidth = form.querySelector('input[name="properties[Wall width (cm)]"]');
    var propHeight = form.querySelector('input[name="properties[Wall height (cm)]"]');

    function unitPrice() {
      var idInput = form.querySelector('input[name="id"]');
      var jsonEl = wrapper.querySelector('[data-product-json]');
      if (!jsonEl) return 0;
      try {
        var product = JSON.parse(jsonEl.textContent);
        var id = idInput ? parseInt(idInput.value, 10) : null;
        var variant = product.variants.find(function (v) { return v.id === id; }) || product.variants[0];
        return variant ? variant.price : 0;
      } catch (e) { return 0; }
    }

    function update() {
      var w = parseFloat(widthInput.value);
      var h = parseFloat(heightInput.value);
      var valid = w > 0 && h > 0;
      if (!valid) {
        if (areaOut) areaOut.textContent = '—';
        if (totalOut) totalOut.textContent = '—';
        if (addBtn) addBtn.disabled = true;
        return;
      }
      var exact = (w / 100) * (h / 100);
      var billable = Math.max(minArea, Math.ceil(exact));
      if (areaOut) areaOut.textContent = exact.toFixed(2) + ' m² (billed as ' + billable + ' m²)';
      if (totalOut) totalOut.textContent = money(unitPrice() * billable);
      var hintEl = calc.querySelector('.wall-calculator__hint');
      if (hintEl) hintEl.textContent = 'Priced at ' + money(unitPrice()) + ' per m² — we print your mural made to measure.';
      if (qtyInput) qtyInput.value = billable;
      if (propWidth) propWidth.value = w;
      if (propHeight) propHeight.value = h;
      if (addBtn) addBtn.disabled = false;
    }

    [widthInput, heightInput].forEach(function (el) {
      if (el) {
        el.addEventListener('input', update);
        el.addEventListener('change', update);
      }
    });
    // recalc when the variant (material) changes
    wrapper.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-index]')) setTimeout(update, 50);
    });
            if (addBtn) { var addLabel = addBtn.getAttribute('data-label-add') || 'Add to cart'; var syncBtn = function () { addBtn.textContent = addBtn.disabled ? 'Enter your wall size above' : addLabel; }; new MutationObserver(syncBtn).observe(addBtn, { attributes: true, attributeFilter: ['disabled'] }); syncBtn(); } var syncPrice = function () { var mp = document.querySelector('.product-info__price'); if (!mp) return; var full = mp.textContent.trim().replace(/\s*per m.*$/, '') + ' per m²'; if (mp.textContent.trim() !== full) mp.textContent = full; var sp = document.querySelector('.sticky-atc__price'); if (sp && sp.textContent.trim() !== full) sp.textContent = full; }; var mpEl = document.querySelector('.product-info__price'); if (mpEl && mpEl.parentNode) new MutationObserver(syncPrice).observe(mpEl.parentNode, { childList: true, subtree: true, characterData: true }); syncPrice(); if (!calc.querySelector('[data-sample-link]')) { var sampleP = document.createElement('p'); sampleP.className = 'wall-calculator__hint'; sampleP.setAttribute('data-sample-link',''); sampleP.style.marginTop = '10px'; sampleP.innerHTML = 'Not sure yet? <a href="/products/sample" style="text-decoration:underline;">Order a £20 sample</a> &mdash; refunded against your mural with code SAMPLE20.'; calc.appendChild(sampleP); } if (!calc.querySelector('[data-render-link]')) { var renderP = document.createElement('p'); renderP.className = 'wall-calculator__hint'; renderP.setAttribute('data-render-link', ''); renderP.style.marginTop = '6px'; var pt = (document.querySelector('h1') || {}).textContent || ''; pt = pt.trim(); var mailto = 'mailto:info@simplymurals.co.uk?subject=' + encodeURIComponent('Free render request: ' + pt) + '&body=' + encodeURIComponent('Hi, please could you show me ' + pt + ' on my wall? My wall is ___ cm wide by ___ cm high. Photo attached.'); renderP.innerHTML = 'Want to see it on your own wall first? <a href="' + mailto + '" style="text-decoration:underline;">Send us a photo</a> and we will send back a free render.'; calc.appendChild(renderP); }
    update();
  });

  /* ---------- order a sample ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sample-add]');
    if (!btn) return;
    e.preventDefault();
    var variantId = parseInt(btn.getAttribute('data-sample-add'), 10);
    if (!variantId) return;
    var designTitle = btn.getAttribute('data-sample-design') || '';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: designTitle ? { 'Sample of': designTitle } : undefined
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return fetch('/cart.js');
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('hidden', cart.item_count === 0);
        });
        return fetch(window.location.pathname + '?sections=cart-drawer');
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        var current = document.getElementById('CartDrawer');
        if (html && current) {
          var temp = document.createElement('div');
          temp.innerHTML = html;
          var fresh = temp.querySelector('#CartDrawer');
          if (fresh) current.innerHTML = fresh.innerHTML;
          current.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        }
      })
      .catch(function () {})
      .finally(function () { btn.disabled = false; });
  });
})();

/* ---------------------------------------------------------------
   Simply Murals — show mural size on the cart page
   Paste this at the very END of assets/mural.js (on a new line).
   It is self-contained and does not touch any existing code.
   --------------------------------------------------------------- */
(function () {
  if (location.pathname.indexOf('/cart') !== 0) return;

  function annotate() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var rows = document.querySelectorAll('tbody tr');
        cart.items.forEach(function (item, i) {
          var row = rows[i];
          if (!row) return;

          var variantEl = row.querySelector('.cart-item__variant');
          if (!variantEl) return;
          if (row.querySelector('[data-sm-size]')) return;

          var props = item.properties || {};
          var w = props['Wall width (cm)'];
          var h = props['Wall height (cm)'];
          if (!w || !h) return;

          var el = document.createElement('p');
          el.className = 'cart-item__variant';
          el.setAttribute('data-sm-size', '');
          el.textContent = item.quantity + ' m² — for a ' + w + ' × ' + h + ' cm wall';
          variantEl.parentNode.insertBefore(el, variantEl.nextSibling);
        });
      })
      .catch(function () { /* leave the cart exactly as it was */ });
  }

  if (document.readyState !== 'loading') {
    annotate();
  } else {
    document.addEventListener('DOMContentLoaded', annotate);
  }
})();
/* ---------------------------------------------------------------
   Simply Murals - wall measurements are mandatory.
   Murals are printed to order and cut to fit, so a line item with
   no wall dimensions cannot be fulfilled. The sample is the only
   product allowed through without them.
   Three guards:
     1. quickview "Add to cart" sends murals to the product page
     2. checkout is blocked while any mural is missing its size
     3. express / accelerated checkout is hidden in that state
   --------------------------------------------------------------- */
(function () {
  var SAMPLE_HANDLES = ['sample'];
  var WIDTH_PROP = 'Wall width (cm)';
  var HEIGHT_PROP = 'Wall height (cm)';
  var CHECKOUT_SELECTOR = 'button[name="checkout"], input[name="checkout"], a[href^="/checkout"], .cart__checkout, .cart__checkout-button, [data-checkout]';
  var EXPRESS_SELECTOR = '.shopify-payment-button, .dynamic-checkout__content, [data-shopify="dynamic-checkout-cart"], [data-shopify="payment-button"]';

  function isSample(handle) {
    return SAMPLE_HANDLES.indexOf(handle) !== -1;
  }

  function needsSize(item) {
    if (isSample(item.handle)) return false;
    var p = item.properties || {};
    return !(p[WIDTH_PROP] && p[HEIGHT_PROP]);
  }

  function handleFromBox(box) {
    var link = box.querySelector('a[href*="/products/"]');
    var href = link ? link.getAttribute('href') : '';
    if (!href) return { handle: '', href: '' };
    var tail = href.split('/products/')[1] || '';
    return { handle: tail.split('?')[0].split('#')[0], href: href };
  }

  /* ---- 1. quickview must not add a mural ---- */
  function interceptQuickview(e) {
    var box = e.target.closest('.quickview, .quick-view, .modal');
    if (!box) return;
    if (!box.querySelector('form[action*="/cart/add"]')) return;
    var info = handleFromBox(box);
    if (isSample(info.handle)) return;
    e.preventDefault();
    e.stopPropagation();
    if (info.href) window.location.href = info.href;
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[type="submit"], button[name="add"], [data-add-to-cart]')) return;
    interceptQuickview(e);
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    interceptQuickview(e);
  }, true);

  /* ---- 2 + 3. hard stop at the checkout ---- */
  var observer;

  function buildWarning(bad) {
    var wrap = document.createElement('div');
    wrap.className = 'mural-size-warning';
    wrap.setAttribute('data-mural-size-warning', '');
    wrap.setAttribute('role', 'alert');

    var head = document.createElement('p');
    head.className = 'mural-size-warning__title';
    head.textContent = 'We need your wall size before you can check out.';
    wrap.appendChild(head);

    var why = document.createElement('p');
    why.textContent = 'These are printed to order and cut to fit, so we cannot make them without measurements:';
    wrap.appendChild(why);

    var ul = document.createElement('ul');
    bad.forEach(function (item) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = item.url || '#';
      a.textContent = item.product_title || item.title || 'This mural';
      li.appendChild(a);
      ul.appendChild(li);
    });
    wrap.appendChild(ul);

    var how = document.createElement('p');
    how.textContent = 'Open each one, enter your wall width and height, then add it to the basket again.';
    wrap.appendChild(how);
    return wrap;
  }

  function apply(cart) {
    var bad = (cart.items || []).filter(needsSize);
    if (observer) observer.disconnect();
    try {
      var old = document.querySelectorAll('[data-mural-size-warning]');
      for (var i = 0; i < old.length; i++) old[i].parentNode.removeChild(old[i]);

      Array.prototype.forEach.call(document.querySelectorAll(CHECKOUT_SELECTOR), function (el) {
        if (bad.length) {
          el.setAttribute('aria-disabled', 'true');
          el.classList.add('is-disabled');
          if ('disabled' in el) el.disabled = true;
        } else {
          el.removeAttribute('aria-disabled');
          el.classList.remove('is-disabled');
          if ('disabled' in el) el.disabled = false;
        }
      });

      Array.prototype.forEach.call(document.querySelectorAll(EXPRESS_SELECTOR), function (el) {
        el.style.display = bad.length ? 'none' : '';
      });

      if (bad.length) {
        var anchor = document.querySelector(CHECKOUT_SELECTOR);
        if (anchor && anchor.parentNode) {
          anchor.parentNode.insertBefore(buildWarning(bad), anchor);
        }
      }
    } finally {
      observe();
    }
    return bad;
  }

  function refresh() {
    if (!document.querySelector(CHECKOUT_SELECTOR)) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(apply)
      .catch(function () {});
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 400);
  }

  function observe() {
    if (!observer) observer = new MutationObserver(schedule);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest(CHECKOUT_SELECTOR);
    if (!el) return;
    if (el.getAttribute('aria-disabled') === 'true' || el.disabled) {
      e.preventDefault();
      e.stopPropagation();
      var warn = document.querySelector('[data-mural-size-warning]');
      if (warn && warn.scrollIntoView) warn.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { refresh(); observe(); });
  } else {
    refresh();
    observe();
  }
  window.addEventListener('pageshow', refresh);
})();
